<template>
  <v-app id="vier-gewinnt-app" class="app-width">
    <vier-gewinnt-status-bar></vier-gewinnt-status-bar>
    <router-view></router-view>
    <v-dialog max-width="350px" class="dialog-width" v-model="showWarningOnlineGs">
      <v-card>
        <v-toolbar dark color="#002EA7">
          <v-toolbar-title>Info</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.stop="setWarningHasBeenShown()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <p>
            Die Daten aus der Online-Geschäftsstelle konnten nicht übernommen
            werden!
          </p>
          <p>
            Bitte geben Sie die Kundendaten und die Bestandsnummer im
            Antragsformular an.
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import VierGewinntNavigation from "./components/4gNavigation";
import VierGewinntStatusBar from "./components/4gStatusBar";

// Listen to the incoming message "sendHostname" to set isOnlineGs
// (see: work.js for explanation why this is necessary)
window.addEventListener(
  "message",
  event => {
    if (event.data.action === "sendHostname") {
      // console.log("Host der übergeordneten Seite:", event.data.hostName);
      this.$store.dispatch(
        "work/receiveHostnameFromParent",
        event.data.hostName
      );
    }
  },
  false
);

export default {
  data: () => ({
    // drawer: null
    // isReloadedCookieText: ""
  }),
  props: {
    source: String
  },
  computed: {
    showWarningOnlineGs() {
      return (
        this.$store.state.work.isOnlineGs &&
        // this.isReloadedCookieText !== "4g is reloaded." &&
        !this.$store.state.work.hasCookie &&
        !this.$store.state.work.checkIsCalled && // damit die Meldung am Ende nicht erscheint, sondern nur am Anfang der Anwendung
        !this.$store.state.work.warningHasBeenShown
      );
    }
  },
  methods: {
    setWarningHasBeenShown() {
      this.$store.commit("work/SET_WARNING_HAS_BEEN_SHOWN", true);
    },
    reload() {
      document.location.reload();
      // console.log("Neu geladen.");  // sichtbar?
    }
  },
  mounted: async function () {
    // this.isReloadedCookieText = Vue.$cookies.get("preventMessageOnlineGS");
    this.$store.dispatch("work/postMessageNewHeight");
    if (this.$route.query.kanalName != undefined) {
      this.$store.commit("work/SET_SALESAGENT_NR", this.$route.query.kanalName);
    } else {
      // console.log("Der Parameter kanalName wurde nicht übergeben.");
    }
    if (this.$route.query.kanalType == "agn") {
      // this is a ad-homepage, so hide agency search in form
      this.$store.commit("work/SET_KANALTYPE", this.$route.query.kanalType);
    }
    // VIS: read cookie if available
    await this.$store.dispatch("work/checkHost");
    this.$store.dispatch("work/readCookie", "visDataTransfer");
    // this.$store.dispatch("work/writeReferrerCookie");
    let self = this;
    console.log("4gewinnt v20260730.00");
  },
  components: { VierGewinntStatusBar }
};
</script>

<style>
#vier-gewinnt-app {
  display: block;
  overflow: hidden;
}

.application {
  line-height: 1;
}

.theme--light.v-navigation-drawer {
  background-color: #ccd5ed;
  color: #002ea7;
}

.theme--light.v-icon {
  color: #002ea7;
}

div.v-toolbar__title {
  font-size: 24px;
}
</style>
